import { render } from "./HelloWorld.vue?vue&type=template&id=4e1e3865&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=4e1e3865&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e1e3865"

export default script